/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'object',
      properties: {
        value: {
          type: 'string',
          enum: ['YES', 'NO', 'NOT_APPLICABLE'],
        },
        followUp: {
          type: ['object', 'null'],
          properties: {
            value: {
              type: 'string',
            },
          },
          required: ['value'],
        },
      },
      required: ['value', 'followUp'],
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    does_the_fac_engage_proactively_w_relevant_stakeholders_before: valueSchema,
  },
}
